/**
 * Toast notifications configuration
 * - base dependency: https://github.com/shakee93/vue-toasted#custom-toast-registration
 *
 * You can use 2 types of notifications starface_succes/starface_error with message and icon params:
 *
 *  - globaly
 * Vue.toasted.global.starface_success({message: 'This is good message!', icon: 'USER'});
 * Vue.toasted.global.starface_error({message: 'This is bad message!', icon: 'USER'});
 *
 *  - inside compoment
 * this.$toasted.global.starface_success({message: 'This is good message!', icon: 'USER'});
 * this.$toasted.global.starface_error({message: 'This is bad message!', icon: 'USER'});
 */

import Vue from 'vue';
import Toasted from 'vue-toasted';
import '../../assets/scss/toast.scss';

Vue.use(Toasted);

const userIcon = require('../../assets/starface_icons_png/24/orange/outline_24.png');
const numbersIcon = require('../../assets/starface_icons_png/24/orange/numbers_24.png');
const groupIcon = require('../../assets/starface_icons_png/24/orange/teams_24.png');
const faxIcon = require('../../assets/starface_icons_png/24/orange/fax_24.png');
const conferenceIcon = require('../../assets/starface_icons_png/24/orange/conference_24.png');
const ratesIcon = require('../../assets/starface_icons_png/24/orange/tarif_24.png');
const addNumberIcon = require('../../assets/starface_icons_png/24/orange/add number_24.png');
const accountIcon = require('../../assets/starface_icons_png/24/orange/stammdaten_24.png');
const invoiceIcon = require('../../assets/starface_icons_png/24/orange/invoice_24.png');

// options to the toast
const options = {
    className: 'starface-notification',
    position: 'bottom-right',
    duration: 5000
};

const getIcon = (icon: string) => {
    switch (icon) {
        case 'USER':
            return userIcon;
        case 'NUMBER':
            return numbersIcon;
        case 'GROUP':
            return groupIcon;
        case 'FAX':
            return faxIcon;
        case 'CONFERENCE':
            return conferenceIcon;
        case 'RATES':
            return ratesIcon;
        case 'ACCOUNT':
            return accountIcon;
        case 'ADD_NUMBER':
            return addNumberIcon;
        case 'FILE':
            return invoiceIcon;
        default:
            return userIcon;
    }
};

const createToast = (data: any, type: 'success' | 'danger') => {
    const message = data.message ? data.message : '';

    return (
        '<div class=' +
        type +
        '>' +
        '<div class=toast-icon>' +
        '<img src=' +
        getIcon(data.icon) +
        ' alt=icon />' +
        '</div>' +
        '<div class=toast-message>' +
        message +
        '</div>' +
        '</div>'
    );
};

export default () => {
    Vue.toasted.register(
        'starface_success',
        (payload: any) => createToast(payload, 'success'),
        options
    );

    Vue.toasted.register(
        'starface_error',
        (payload: any) => createToast(payload, 'danger'),
        options
    );
};
